import type { Resource } from '../../';
export const product_price_originalPrice: Resource = {"default":"Original Price {price}"};
